<script setup lang="ts">
    import BackButton from '@/components/BackButton.ce.vue';
    import ProgressBar from './ProgressBar.ce.vue';

    defineProps<{
        back?: string
        step: number
        total: number,
        noHeader?: boolean
        noProgress?: boolean
    }>();

    const emit = defineEmits<{(event: 'back')}>();

    // Constants
    const BG_IMG = `${import.meta.env.VITE_CDN_URL}/static/background_results.png`;
</script>

<template>
    <div
        :style="{
            backgroundImage: step === 15 ? `url(${BG_IMG})` : '',
        }"
        class="quote-layout"
    >
        <template v-if="!noHeader">
            <ProgressBar
                v-if="!noProgress"
                :current="step"
                :total="total"
            />
            <div
                v-if="back"
                :class="{
                    'quote-layout__back-btn--no-progress': noProgress
                }"
                class="quote-layout__back-btn"
            >
                <BackButton
                    :text="back"
                    :on-click="() => emit('back')"
                />
            </div>
        </template>
        <div class="quote-layout__content">
            <slot />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.quote-layout {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    justify-content: space-between;
    background: var(--background-primary);
    background-position: center;
    background-size: cover;
    block-size: 100%;
    inline-size: 100%;

    &__content {
        overflow: auto;
        flex: 2;
        -ms-overflow-style: none; /* IE & Edge */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
            display: none; /* Chrome, Safari */
        }
    }

    &__back-btn {
        display: flex;

        &--no-progress {
            padding-block-start: var(--spacing-03)
        }

        @include min-width(md) {
            padding-inline-start: var(--spacing-05);
        }

        @include min-width(lg) {
            padding-inline-start: var(--spacing-07);
        }
    }
}
</style>
